import { useQuery } from 'react-query';
import { fetchFormaCards, FetchFormaCardsResponse } from 'apis/formaCards';

export type IFormaCard = FetchFormaCardsResponse['cards'][0];

const getFormaCards = async (): Promise<{ forma_cards: Array<IFormaCard> }> => {
  const { data } = await fetchFormaCards();
  return { forma_cards: data };
};

const useQueryFormaCards = () => {
  const {
    data,
    isLoading: is_loading,
    refetch,
  } = useQuery(['getFormaCards'], () => getFormaCards());

  return {
    data,
    is_loading,
    refetch,
  };
};

export default useQueryFormaCards;
